var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#272830"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7071 8.70696C9.31658 8.31643 8.68341 8.31643 8.29289 8.70696C7.90237 9.09748 7.90237 9.73065 8.29289 10.1212L14.8387 16.667L8.7071 22.7987C8.31658 23.1892 8.31658 23.8224 8.7071 24.2129C9.09762 24.6034 9.73078 24.6034 10.1213 24.2129L16.2529 18.0813L22.3845 24.2129C22.775 24.6034 23.4082 24.6034 23.7987 24.2129C24.1892 23.8224 24.1892 23.1892 23.7987 22.7987L17.6671 16.667L24.2129 10.1212C24.6034 9.73065 24.6034 9.09749 24.2129 8.70696C23.8224 8.31643 23.1892 8.31643 22.7987 8.70696L16.2529 15.2528L9.7071 8.70696Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCard);
export default __webpack_public_path__ + "static/media/close-card.79bd9628035ae6ca7f6e578c318e7e8e.svg";
export { ForwardRef as ReactComponent };